/*
 * The blanks of Eklevo's model of the information notice (tools/docgen, content-privacy-notice-model):
 * a text pasted from the model with one still unfilled would go out to a company's people as
 * written, so a notice's text with one is refused, in every channel that publishes it (decided on
 * 2026-11-02). Only the model's literal names count: other square brackets, such as «[Anexo I]»,
 * are a company's own text. A notice given as an address cannot be checked.
 */

/** A paragraph the model marks as conditional starts with one of these; what follows varies. */
const CONDITION_PREFIXES = ['[Only if', '[Solo si', '[Només si'] as const

/** Every blank of the model, in its three languages. A test keeps it equal to the model's source. */
export const NOTICE_MODEL_PLACEHOLDERS: readonly string[] = [
  '[Organization]',
  '[tax ID]',
  '[address]',
  '[privacy contact]',
  '[DPO contact]',
  '[Provider company]',
  '[legal basis]',
  '[address of the privacy policy]',
  '[Organización]',
  '[NIF]',
  '[domicilio]',
  '[contacto de privacidad]',
  '[contacto del DPD]',
  '[Empresa proveedora]',
  '[base jurídica]',
  '[dirección de la política de privacidad]',
  '[Organització]',
  '[domicili]',
  '[contacte de privacitat]',
  '[contacte del DPD]',
  '[Empresa proveïdora]',
  '[adreça de la política de privacitat]',
  ...CONDITION_PREFIXES,
]

/**
 * The model's blanks a notice's text still has, by where they first appear; none when it has been
 * filled in. Only names from the list above come out, never anything else of the text: they can be
 * shown or logged.
 */
export function findNoticePlaceholders(body: string): string[] {
  const text = body.normalize('NFC')
  return NOTICE_MODEL_PLACEHOLDERS.map((name) => ({ name, at: text.indexOf(name) }))
    .filter(({ at }) => at >= 0)
    .sort((a, b) => a.at - b.at)
    .map(({ name }) => name)
}

/** A form's field has a problem as a path and a code: this code also says which blanks it has. */
const ISSUE_CODE = 'placeholder:'

/** The code of a field's problem when its text has these blanks. */
export function noticePlaceholderCode(found: readonly string[]): string {
  return `${ISSUE_CODE}${found.join(', ')}`
}

/** The blanks a field's problem names, for its message; null for any other problem. */
export function placeholdersOfCode(code: string): string | null {
  return code.startsWith(ISSUE_CODE) ? code.slice(ISSUE_CODE.length) : null
}
